import { Formation } from "../types"

export const pos66: Formation = {
  id: "pos66",
  name: "Basic - Default",
  category: "6 - 6",
  snapshots: [
    {
      players: [
        {
          x: 7.163291575660843,
          y: 8.256962893541854
        },
        {
          x: 3.2651270566732937,
          y: 6.608190775772149
        },
        {
          x: 11.636864118678595,
          y: 7.12878246603616
        },
        {
          x: 13.220890204681433,
          y: 3.1127173493270237
        },
        {
          x: 6.390104049992533,
          y: 4.107241066553259
        },
        {
          x: 0.824652741317111,
          y: 3.13477776640205
        }
      ],
      opponents: [
        {
          x: 6.824305818072356,
          y: 7.310982507047118
        },
        {
          x: 4.121382208565515,
          y: 5.868313915840614
        },
        {
          x: 1.6661239861017771,
          y: 3.684582417441383
        },
        {
          x: 7.257877217683599,
          y: 3.750754991027759
        },
        {
          x: 12.290109322204955,
          y: 3.6586889633853232
        },
        {
          x: 10.804164726959192,
          y: 6.589522385682684
        }
      ],
      ball: {
        x: 7.873947726925357,
        y: 7.981978440370184
      },
      goalkeepers: [
        {
          x: 6.925088223875495,
          y: 0.990639234244325
        }
      ]
    }
  ]
}
